import ProductTable from "../../components/table/ProductTable";

export default function ProductControl() {
	return (
		<section className="w-full h-full px-8">
			<ProductTable />
		</section>
	);
}
